import React, { useEffect, useRef, useState } from 'react'
import { Check, ChevronDown } from 'lucide-react'

export default function Picker({ value, onChange, options, placeholder, icon: Icon, compact }) {
  var [open, setOpen] = useState(false)
  var rootRef = useRef(null)
  var selected = options.find(function (option) { return option.value === value })

  useEffect(function () {
    function closeWhenOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false)
    }
    document.addEventListener('mousedown', closeWhenOutside)
    document.addEventListener('touchstart', closeWhenOutside)
    return function () {
      document.removeEventListener('mousedown', closeWhenOutside)
      document.removeEventListener('touchstart', closeWhenOutside)
    }
  }, [])

  return <div ref={rootRef} className="relative w-full">
    <button type="button" onClick={function () { setOpen(!open) }} className={'flex w-full items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 text-sm font-medium text-slate-800 outline-none transition-colors hover:border-slate-300 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 ' + (compact ? 'h-8 text-xs' : 'h-10 shadow-xs')}>
      {Icon && <Icon className="size-4 shrink-0 text-slate-400" strokeWidth={2} />}
      <span className={'flex-1 truncate text-left ' + (!selected ? 'font-normal text-slate-400' : '')}>{selected ? selected.label : placeholder}</span>
      <ChevronDown className={'size-4 shrink-0 text-slate-400 transition-transform ' + (open ? 'rotate-180' : '')} strokeWidth={2} />
    </button>
    {open && <div className="absolute left-0 right-0 z-50 mt-1.5 max-h-60 overflow-y-auto rounded-lg bg-white py-1 shadow-md ring-1 ring-slate-900/5">
      {options.map(function (option) {
        var isSelected = option.value === value
        return <button key={option.value} type="button" onClick={function () { onChange(option.value); setOpen(false) }} className={'flex w-full items-start gap-3 px-3 py-2.5 text-left outline-none transition-colors ' + (isSelected ? 'bg-blue-50' : 'hover:bg-slate-50')}>
          <div className={'min-w-0 flex-1 ' + (isSelected ? 'pr-1' : 'pr-7')}>
            <div className={'text-sm ' + (isSelected ? 'font-semibold text-blue-700' : 'font-medium text-slate-800')}>{option.label}</div>
            {option.description ? <div className="mt-0.5 truncate text-[11px] text-slate-400">{option.description}</div> : null}
          </div>
          {isSelected && <Check className="mt-0.5 size-4 shrink-0 text-blue-600" strokeWidth={3} />}
        </button>
      })}
    </div>}
  </div>
}
